module.exports = __webpack_public_path__ + "7a4ea0a55cd272064d3b73783e62deb1.pdf";